import React, { useState } from "react";
// imoprt Email
import Email from "../assets/img/common/email.png";
import EmailSender from '../api/EmailSender';

const CtaArea = () => {
  const { isSubmitting, succeeded, error, sendEmail } = EmailSender();
  const [emailValue, setEmailValue] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formData = { email: emailValue };
    const success = await sendEmail(
      formData,
      "Newsletter Subscription from House of Polani"
    );

    if (success) {
      setEmailValue("");
    }
  };

  return (
    <>
      <section id="cta_area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="cta_left">
                <div className="cta_icon">
                  <img src={Email} alt="icon" />
                </div>
                <div className="cta_content">
                  <h4>Get the latest news and offers</h4>
                  <h2>Subscribe to our newsletter</h2>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="cat_form">
                <form
                  onSubmit={handleSubmit}
                  id="tour_bookking_form_item"
                  className=""
                >
                  <div className="input-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter your mail address"
                      name="email"
                      value={emailValue}
                      onChange={(e) => setEmailValue(e.target.value)}
                      required
                    />
                    <button
                      type="submit"
                      className="btn btn_theme btn_md"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Subscribe"}
                    </button>
                  </div>
                  {error && (
                    <div className="col-lg-12">
                      <div className="vendor_form_heading">
                        <p className="text-danger mt-2">{error}</p>
                      </div>
                    </div>
                  )}
                  {succeeded && (
                    <div className="col-lg-12">
                      <div className="vendor_form_heading">
                        <h5 className="mt-2">
                          Thank You! Subscribe Successfully
                        </h5>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CtaArea;
